import { combineReducers } from 'redux';
import authReducer from "./reducers/auth.reducer";

const reducers = combineReducers({
    auth: authReducer
});

export default reducers;
